define('Components/LandingWidget/js/views/SummerBoxWidgetInstanceView',['jquery', 'app', 'Components/LandingWidget/js/views/LandingWidgetInstanceView'],
    function ($, app, LandingWidgetInstanceView) {
        return LandingWidgetInstanceView.extend({

            events: {
                'click .cta': "ctaAddtoCart"
            },
            
            afterRender: function () {

                var view = this;
                //
                view.listenTo(app.getCart().getProducts(), 'add', view.onAddProduct);
                //
                view.listenTo(app, 'change:scrollTop', view.onScroll);
                setTimeout(function () {
                    view.onScroll();
                }, 500);

            },
            
            onScroll:function(){
                var view = this;
                view.$('.animate-on-scroll').each(function () {
                    if ($(window).scrollTop() > $(this).offset().top - $(window).height() * 0.75) {
                        $(this).addClass('active');
                    }
                });
            },
            
            ctaAddtoCart: function (e) {
                var view = this,
                    id_product = view.$(e.currentTarget).data('idproduct');
                app.getCart().addProduct(id_product);
            },
            
            onAddProduct: function () {
                app.bottomNotice(app.t('Le produit a bien été ajouté au panier', 'Cart'));
            }
            
        })
});
